// Navigation des Moduls `wissen` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul wissen.
import { Books, Database, ListMagnifyingGlass } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'wissen',
  title: 'Knowledge & company storage',
  nav: {
    admin: [
      {
        key: 'wissen.storage',
        label: 'Knowledge & storage',
        icon: Books,
        path: '/knowledge',
        roles: ['ADM'],
        order: 710,
        area: 'Knowledge',
      },
      {
        key: 'wissen.sources',
        label: 'App data sources',
        icon: Database,
        path: '/knowledge/sources',
        roles: ['ADM'],
        order: 720,
        area: 'Knowledge',
      },
      {
        key: 'wissen.index',
        label: 'Index',
        icon: ListMagnifyingGlass,
        path: '/knowledge/index',
        roles: ['ADM'],
        order: 730,
        area: 'Knowledge',
      },
    ],
    ai: [
      {
        key: 'wissen.knowledge',
        label: 'Knowledge',
        icon: Books,
        path: '/knowledge',
        roles: ['ALL'],
        order: 40,
        area: 'sidebar',
      },
    ],
  },
});
